export const tags = [
  { text: 'All Filers', value: 3 },
  { text: 'Closed-End Funds', value: 1 },
  { text: 'Tiger Cubs', value: 2 },
  { text: 'Open-End Funds', value: 6 }
]

export const defaultSelectedGroup = Object.freeze({
  id: null,
  description: 'New Group',
  visibility_type_id: 0,
  filers: []
})

export const defaultAlertCriteria = Object.freeze({
  id: null,
  name: null,
  last_email_date: null,
  delivery_type_id: 1,
  funds_and_stocks: {
    predefined_id: null,
    stock_group: { id: null, stocks: [] },
    filer_group: {
      id: null,
      filers: []
    },
    stock_basket: [],
    stock_basket_action: 1,
    whaleindices: []
  },
  form_types: [],
  form8k_events: [],
  formd_industry_groups: [],
  formd_securities: [],
  formd_states: [],
  formd_investment_funds: [],

  settings: {
    filer_type_selection: 3,
    form_type_selection: 'all'
  }
})

export const defaultBacktesterCriteria = Object.freeze({
  adr_only: false,
  backtesting_days: 46,
  backtesting_days_submitted: false,
  consensus_min_filers: null,
  consensus_min_percent_portfolio: null,
  double_down: {
    selected: false,
    percent_decline: 25,
    purchase_percent: 25,
    percent_of_portfolio: 5,
    check_for_13d: false,
    percent_increase: null,
    stdev_decline: null
  },
  earliest_quarter: 0,
  ending_quarter: 0,
  etf_only: false,
  exclude_adr: false,
  exclude_etf: false,
  exclude_stocks_change_in_shares_decrease: null,
  exclusion_less_than: null,
  exclusion_more_than: null,
  exclusion_tickers: '',
  filer_group_id: null,
  filer_performance: {
    selected: false,
    max_filers: 10,
    top_performing_type: {
      description: 'Do not select filers based on performance',
      value: 0,
      requires_subscription: true
    },
    turnover_type: {
      description: 'Any',
      value: 0,
      requires_pro_subscription: true
    },
    top10_type: {
      description: 'Any',
      value: 0,
      requires_pro_subscription: true
    },
    holdings_from_to: [5, 1000],
    mc_from_to: [100, 400000],
    use_holdings: true,
    use_quarters: false,
    quarters_min: null,
    quarters_max: null,
    use_mc: true,
    time_held_top10_from_to: [4, 8],
    use_time_held_top10: false,
    adv_insider_ownership: null
  },
  filers: [],
  heat_map: false,
  hedge_moving_average_target: 0,
  hedging_investment: 2,
  hedging_moving_average_months: 10,
  hedging_percentage: 25,
  hedging_type: 0,
  holdings: 1,
  market_caps: [],
  no_rebalancing: false,
  no_weight_adjustment: false,
  only_include_stocks_change_in_shares_increase: null,
  quarter_one: {},
  quarter_two: {},
  rebalance_frequency: 1,
  sectors: [],
  sell_buffer_threshold: 0,
  stock_selection_group: 6,
  stock_selection_top_ranking: 10,
  stock_weight_group: 2,
  stop_loss_decline_from_purchase: null,
  stop_loss_enabled: false,
  stop_loss_increase_from_purchase: null,
  stocks_vs_sp: {
    enabled: false,
    percent_threshold: 10.0,
    months: 3,
    up_or_down: 'down',
    plus_minus: null
  },
  whalescore: null,
  max_quarters_held: null,
  use_original_filings: false,
  overweight: false
})

export const defaultInsiderBacktesterCriteria = Object.freeze({
  entry_owners: [],
  excluded_owners: [],
  entry_stocks: [],
  excluded_stocks: [],
  entry_cluster_buy_criteria: {},
  starting_amount: 10000,
  start_date: '2017-1-1',
  end_date: null,
  portfolio_weighting: '2',
  portfolio_weighting_percent_entry: 10,
  exit_stop_loss: 30,
  exit_stop_loss_enabled: true,
  exit_trailing_stop_loss: null,
  exit_stop_gain: 50,
  exit_stop_gain_enabled: false,
  exit_trailing_stop_gain: null,
  exit_elapsed_time_enabled: true,
  exit_elapsed_time: 90,
  fully_invested_buy_up_to_cash_available: false,
  fully_invested_exit_fifo: true,
  fully_invested_exit_underperform: false,
  days_after_acceptance_date: 1,
  market_caps: [],
  limit_new_purchases_days: null,
  stock_price_ma: null,
  stock_price_ma_below: null,
  stock_price_ma_above: null,
  hold_until_profit_or_fully_invested: false,
  use_volatility_adjusted_trading_size: false,
  volatility_adjusted_stddev_time: 0,
  volatility_min_ratio: 0.25,
  volatility_max_ratio: 2.0
})

export const defaultInsiderBacktesterClusterCriteria = Object.freeze({
  transaction_type: 4,
  date_range: 1,
  owner_types: [5],
  minimum_unique_owners: '3',
  minimum_transaction_amount: '100000',
  industries: [],
  sectors: [],
  minimum_percent_ownership: '',
  avg_daily_volume_from: '',
  avg_daily_volume_to: '',
  exclude_public_offering: true,
  is_10b5: false,
  market_caps: [],
  minimum_transaction_count: '',
  stock_price_min: '',
  stock_price_max: '',
  avg_dollar_value_volume_min: '',
  avg_dollar_value_volume_max: '',
  buy_reversal: false,
  restrict_recent_52_week_high: false,
  restrict_recent_52_week_low: false,
  restrict_percent_52_week_high: null,
  restrict_percent_52_low_high: null,
  restrict_percent_52_week_high_to: null,
  restrict_percent_52_low_high_to: null
})
